import React from "react";

import { useT } from "src/internationalization";

type TextErrorProps = {
  message: string;
};

// Used to display an error as a red plain text
// Typically used in field forms and inside table rows where a notification would be too big
const TextError: React.FC<TextErrorProps> = ({ message }) => {
  const t = useT();

  return (
    <div className="text-supportError">
      {t("component.error.text.label")}: {message}
    </div>
  );
};

export default TextError;
